export const MAX_ITEMS_ON_PAGE = 50;
